<template>
  <v-card flat>
    <v-card-text class="py-0">Search by client...</v-card-text>
    <invoice-lookup ref="lookup" @setSelected="setSelected"></invoice-lookup>
    <v-row dense>
      <v-col cols="12" sm="3">
        <date-picker
          :value="invoiceDate"
          :field="{ label: 'Invoice Date' }"
          @fieldChange="invoiceDate = $event"
          :validations="{ required: true }"
        ></date-picker> </v-col
    ></v-row>
    <v-card-actions>
      <v-btn
        color="primary"
        :dark="selected.length !== 0"
        :disabled="selected.length === 0"
        @click="save"
      >
        Save
      </v-btn>
      <confirm-modal ref="confirm"></confirm-modal>
      <v-btn color="primary" text @click="cancel"> Cancel </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>
<script>
import InvoiceLookup from "../Payments/invoice-lookup.vue";
import ConfirmModal from "../Shared/confirm-modal.vue";
export default {
  components: {
    InvoiceLookup,
    ConfirmModal,
  },
  data() {
    return {
      selected: [],
      invoiceDate: new Date(),
    };
  },
  methods: {
    setSelected(value) {
      this.selected = value;
    },
    cancel() {
      this.$router.push({ name: "Home" });
    },
    async save() {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          `This will revert and uninvoice ${this.selected.length} session(s). Continue?`
        )
      ) {
        this.$store.commit("uxModule/setShowLoader", true);
        let message = await this.$store.dispatch(
          "billingModule/revertSessionInvoices",
          {
            sessionInvoices: this.selected,
            invoiceDate: this.invoiceDate,
          }
        );

        this.$store.commit("uxModule/setShowLoader", false);
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          message || "Successfully reverted invoices"
        );
        this.$store.commit("uxModule/setShowSnackbar", true);

        // refresh invoice-lookup
        this.$refs.lookup.clearSelected();
        this.$refs.lookup.loadData();
      }
    },
  },
};
</script>
